// extracted by mini-css-extract-plugin
module.exports = {"select-wrapper":"style_select-wrapper__3XN7s","label":"style_label__2fjXM","select":"style_select__wCMxM","error":"style_error__2Rlz9"};